import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-800 text-foreground-100">
      <div className="w-full px-4 md:px-8 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-xl font-bold text-background-50 mb-4">
              <Link to="/" className="hover:text-primary-400 transition-colors cursor-pointer">韩漫</Link>
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              韩漫网站——免费阅读高质量韩国漫画，下拉式流畅浏览体验，精选好看韩国漫画大全，满足您所有漫画阅读需求。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/all" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">漫画分类</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2">
              <li><Link to="/category/romance" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">恋爱漫画</Link></li>
              <li><Link to="/category/action" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">动作漫画</Link></li>
              <li><Link to="/category/fantasy" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">奇幻漫画</Link></li>
              <li><Link to="/category/thriller" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">悬疑漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-base"></i>
                <span>contact@hanman.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-wechat-line text-base"></i>
                <span>微信公众号：韩漫阅读</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-smartphone-line text-base"></i>
                <span>客服热线：400-888-9999</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 韩漫 - 韩国漫画大全。本站所有漫画内容均来自网络，版权归原作者所有。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
              <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}